import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getJobs({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_JOBS_REQUEST')

        return axios
            .get(`/jobs/jobs${paginate}${query}`)
            .then(response => {
                commit('GET_JOBS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_JOBS_FAILURE')
                handleApiError(error, 'Pobranie listy zleceń nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getJob(context, id) {
        return axios
            .get(`/jobs/jobs/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych zlecenia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getJobChangeHistory(context, jobId) {
        return axios
            .get(`/jobs/jobs/${jobId}/change-history`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie historii zmian dla zlecenia ${jobId} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    getJobNotes(context, jobId) {
        return axios
            .get(`/jobs/jobs/${jobId}/job-notes`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Nie udało się pobrać danych o uwagach jakościowych.')

                return Promise.reject(error)
            })
    },
    getJobNumbers(_, { query = '' }) {
        return axios
            .get(`/jobs/job-numbers${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie numerów zleceń nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createJob(context, payload) {
        return axios
            .post('/jobs/create-new-job', payload, {
                timeout: 0
            })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Utworzenie zlecenia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    saveJob(context, payload) {
        return axios
            .patch(`/jobs/jobs/${payload.id}`, payload, {
                timeout: 0
            })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Aktualizacja zlecenia nie powiodła się.')

                return Promise.reject(error)
            })
    },
    saveImposition(context, payload) {
        return axios
            .patch(`/jobs/impositions/${payload.id}`, payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Aktualizacja impozycji nie powiodła się.')

                return Promise.reject(error)
            })
    },
    saveTask(context, payload) {
        return axios
            .patch(`/jobs/imposition-tasks/${payload.id}`, payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Aktualizacja procesu nie powiodła się.')

                return Promise.reject(error)
            })
    },
    addTask(context, payload) {
        return axios
            .post('/jobs/imposition-tasks', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie procesu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    deleteTask(context, payload) {
        return axios
            .delete(`/jobs/imposition-tasks/${payload.id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie procesu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    copyTaskParameters(context, payload) {
        return axios
            .post('/jobs/imposition-tasks/copy-parameters', {
                sourceTaskId: payload.sourceTaskId,
                targetTaskId: payload.targetTaskId
            })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Kopiowanie parametrów procesu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProcessesAvailableToAdd(context, payload) {
        return axios
            .get(`/production-processes/processes/${payload.task.processId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie procesów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getJobPrintColors({ commit }, {
        query = ''
    } = {}) {
        return axios
            .get(`jobs/dicts/job-print-colours${query}`)
            .then(response => {
                commit('GET_JOB_PRINT_COLORS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie typów kolorów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getJobColourTemplates() {
        return axios
            .get('/jobs/dicts/job-colour-templates')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych wzorów kolorystycznych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getOrderComponents({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_ORDER_COMPONENTS_REQUEST')

        return axios
            .get(`/orders/order-components${paginate}${query}`)
            .then(response => {
                commit('GET_ORDER_COMPONENTS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_ORDER_COMPONENTS_FAILURE')

                handleApiError(error, 'Pobranie komponentów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    reprintJob({ commit }, payload) {
        return axios
            .post('/jobs/reprint-jobs', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zlecenie dodruku zostało utworzone.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodruk nie powiódł się.')

                return Promise.reject(error)
            })
    },
    printJobReports(context, payload) {
        return axios
            .post('/jobs/jobs/card-print', payload, {
                responseType: 'arraybuffer'
            })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    componentsToImpositions(context, payload) {
        return axios
            .post('/jobs/reassign-components-to-impositions', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja zbiorcza komponentów nie powiodła się.')

                return Promise.reject(error)
            })
    },
    getParallelComponents(context, taskId) {
        return axios
            .get(`/jobs/imposition-tasks/${taskId}/parallel-components`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie komponentów procesów równoległych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    saveParallelComponents(context, components) {
        return axios
            .post('/jobs/imposition-tasks/reassign-parallel-components', components)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Przypisanie komponentów do zadań nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductTypeConfigurations({ commit }, payload) {
        const productTypeId = payload.productTypeId

        return axios
            .get(`jobs/imposition-product-type-configuration?impositionProductTypeConfigurationTypeCode=JMD&productType_id=${productTypeId}`)
            .then(response => {
                commit('GET_PRODUCT_TYPE_CONFIGURATIONS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie konfiguracji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getJobDieCutters({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_JOB_DIE_CUTTERS_REQUEST')

        return axios
            .get(`/jobs/jobs/die-cutters${paginate}${query}`)
            .then(response => {
                commit('GET_JOB_DIE_CUTTERS_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_JOB_DIE_CUTTERS_FAILURE')
                handleApiError(error, 'Pobranie wykrojników nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getJobMachines({ commit }, {
        paginate = '',
        query = '',
        shouldSavedInStore = true
    } = {}) {
        commit('GET_MACHINES_REQUEST')

        return axios
            .get(`/jobs/jobs/machines${paginate}${query}`)
            .then(response => {
                if (shouldSavedInStore) commit('GET_MACHINES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_MACHINES_FAILURE')
                handleApiError(error, 'Pobranie maszyn nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setJobsFilters({ commit }, filters) {
        commit('SET_JOBS_FILTERS', filters)
    },
    clearJobsFilters({ commit }) {
        commit('CLEAR_JOBS_FILTERS')
    },
    sendMaterialsRequirement(context, payload) {
        return axios
            .post('/jobs/jobs/send-material-requirement', { jobId: payload.id })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wysłanie zapotrzebowania nie powiodło się.')

                return Promise.reject(error)
            })
    }
}
